<template>
<span>
    <hydroware-edit-button v-if="EV=='E'"
        v-bind="$attrs"
        v-on="$listeners"
        :text = text
    >
    </hydroware-edit-button>
    <hydroware-view-button v-if="EV=='V'"
        v-bind="$attrs"
        v-on="$listeners"
        :text = text
    >
    </hydroware-view-button>
</span>
</template>
<script>
export default {
  //A Boolean value (or null) is used to decide on the button to display
  //  true  - the edit button is displayed
  //  false - the view button is displayed
  //  null  - neither button is displayed
  props: {
    EV:null,
    text: null
  }
}
</script> 


// WEBPACK FOOTER //
// hydroware-viewOrEdit-button.vue?774ae671